import { CONFIG } from '@arrived/config';

export const GOOGLE_MAPS_SCRIPT_SRC = `https://maps.googleapis.com/maps/api/js?key=${CONFIG.googleApiKey}&libraries=places,geocode`;
